import { Component, OnInit } from '@angular/core';
import { DigiServiceService } from '../services/digi-service.service';
import { MatDialog } from '@angular/material';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';

@Component({
  selector: 'app-digi-analysis',
  templateUrl: './digi-analysis.component.html',
  styleUrls: ['./digi-analysis.component.scss']
})
export class DigiAnalysisComponent implements OnInit {
  lastUpdate = new Date();
  lastStart = new Date();
  metrics:any = {
  KWH: 0,
  KVAH: 0,
  KVARH: 0,
  PF: 0,
  runningHours: 0,
  energyEfficiency: 0,
  loadFactor: 0,
  fuelRatePerKWh: 0,
  totalFuel: 0,
  fuelUnitPrice: 0
  };

  generatorIds: any;
  selectedDevice: any;
  timeFilter: any;
  timeOptions: any = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
  customeSelectedDate: any;
  selectedFilter: any;
  currentUserData = JSON.parse(localStorage.getItem('userData'));
  generatorInfo: any;
  totalHours: any = 0;
  TotalKw: any=0;
selectedDuration:any;
  constructor(private digiService:DigiServiceService,private matDialog: MatDialog) { }

  ngOnInit() {
    this.getDigiIds();
    this.timeFilter = 'Today';
    this.filters('Today');
  }
  getDigiIds(){
    this.digiService.getDigiIds({userid:this.currentUserData.userid}).subscribe(resp=>{
      if(resp.status){
        this.generatorIds = resp.result;
        this.selectedDevice = resp.result[0]
        console.log("gebnerators id",this.selectedDevice)
      }
    })
  }
  onDeviceSelect(){
    this.filters(this.selectedDuration)
  }
  filters(duration:any){
      this.selectedDuration = duration;
        if (duration == "Custom") {
          let dialogRef = this.matDialog.open(CustomDateComponent, {
            autoFocus: false,
            height: '350px', width: '450px', data: { "details": "", "action": "Add",selectedDate:this.customeSelectedDate}
        });
  
  
        dialogRef.afterClosed().subscribe(value => {
          console.log("Value======= ", value);
          if (value) {
            this.selectedFilter = {...value,duration: duration,deviceid:this.selectedDevice.deviceid}
            this.customeSelectedDate = value;
          }
          this.getReportData(this.selectedFilter)
          this.getDeviceInfo(this.selectedDevice.deviceid)
        });
        } else{
          this.selectedFilter = {duration:duration,deviceid:this.selectedDevice.deviceid};
          this.getReportData(this.selectedFilter)
          this.getDeviceInfo(this.selectedDevice.deviceid)
        }
  
    }
    getReportData(filter){
      console.log(filter)
      this.digiService.getReportData(filter).subscribe(res=>{
        if(res.status){
          this.metrics.KWH = (Number(res.result[res.result.length-1].KWH- res.result[0].KWH)).toFixed(2)
          this.metrics.KVAH = (Number(res.result[res.result.length-1].KVAH- res.result[0].KVAH)).toFixed(2)
          this.metrics.KVARH = (Number(res.result[res.result.length-1].KVARH- res.result[0].KVARH)).toFixed(2)
          this.metrics.energyEfficiency = (Number(this.metrics.KWH)/Number(this.metrics.KVAH)).toFixed(2)
          this.metrics.runningHours = this.calculateRunningHours(res.result);
          this.metrics.loadFactor = this.calculateLoadFactor(res.result[res.result.length-1])
          //this.TotalKw = _.sumBy(res.result, 'Total_KW').toFixed(2);
        } else {
          this.metrics.KWH = 0
          this.metrics.KVAH = 0
          this.metrics.KVARH = 0
          this.metrics.energyEfficiency = 0
          this.metrics.runningHours = 0
          this.metrics.loadFactor = 0
        }
      })
    }
    calculateLoadFactor(data: any): any {
      const Vavg = (data.L1L2_Voltage + data.L2L3_Voltage + data.L3L1_Voltage) / 3;
      const Iavg = (data.L1_Current + data.L2_Current + data.L3_Current) / 3;
      const PF = data.PF || 1; // fallback 1 if missing
    
      const PtotalKW = Math.sqrt(3) * Vavg * Iavg * PF / 1000;
      const loadFactor = PtotalKW / this.generatorInfo.capacity;
      return Number(loadFactor.toFixed(2));
    }    
    calculateRunningHours(data: any): number {
      if (!data.length) return 0;
    
      // Sort logs by date
      const sortedData = data.sort(
        (a, b) => new Date(a.Date).getTime() - new Date(b.Date).getTime()
      );
    
      let totalMinutes = 0;
    
      for (let i = 1; i < sortedData.length; i++) {
        const prev = sortedData[i - 1];
        const curr = sortedData[i];
    
        const diffMs = new Date(curr.Date).getTime() - new Date(prev.Date).getTime();
        const diffMinutes = diffMs / (1000 * 60);
    
        // Generator ON if KW > 0
        const prevRunning = prev.Total_KW > 0;
        const currRunning = curr.Total_KW > 0;
    
        // If both running and gap <= 5 minutes, add to running time
        if (prevRunning && currRunning && diffMinutes <= 20) {
          totalMinutes += diffMinutes;
        }
      }
    
      return parseFloat((totalMinutes / 60).toFixed(2)); // hours
    }
    getDeviceInfo(deviceid){
      this.digiService.getGeneratorByDeviceid({deviceid:deviceid}).subscribe(res=>{
        if(res.status){
          console.log("Device Info",res.result)
          this.generatorInfo =res.result;
        }
      })
    }
}
